// JsFromRoutes CacheKey 5c222a8865a009531c096600f63e853e
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  explore: /* #__PURE__ */ definePathHelper('get', '/admin/prospects/:prospect_id/quote/:id/explore'),
  processing: /* #__PURE__ */ definePathHelper('get', '/admin/prospects/:prospect_id/quote/:id/processing'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/prospects/:prospect_id/quote/:id'),
}
